import axios from 'axios'

class TeacherService {
  async save (teacher, url = '/teachers', isPrevious = false, previousUrl = null) {
    try {
      const response = await axios({
        url,
        method: 'post',
        data: {
          ...teacher
        }
      })

      if (response.status === 200 && response.data.band) {
        if (isPrevious) {
          window.location.href = previousUrl
        } else {
          window.location.href = response.data.redirect
        }
      }
    } catch (error) {
      console.error(error)
    }
  }

  async fileSave (teacher, files, url) {
    try {
      const formData = new FormData()

      formData.append('titleStatement', teacher.titleStatement)
      formData.append('statement', teacher.statement)
      formData.append('useImpactStatementMaterial', teacher.useImpactStatementMaterial)
      formData.append('coverPhoto', files.coverPhoto)
      formData.append('profilePhoto', files.profilePhoto)

      const response = await axios({
        url,
        method: 'POST',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })

      if (response.status === 200 && response.data.band) {
        window.location.href = response.data.redirect
      }
    } catch (error) {
      console.log(error)
    }
  }
}

export default TeacherService



// WEBPACK FOOTER //
// ./resources/js/services/TeacherService.js